import React, { useEffect, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import { useQuery } from 'urql'
import { ResourceCategoriesQuery } from '../../../graphql/documents'
import useDisplayError from '../../../hooks/useDisplayError'
import PageNavContainer from '../../../state/PageNavContainer'
import OldAppHeader from '../../AppModule/App/OldAppHeader'
import LoadOverlay from '../../shared/LoadOverlay'
import Resources from './Resources/Resources'
import {
  createCombinedResourcesQuery,
  mapCategoriesToQueryVariables,
} from '../../../utils/resources'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `resources`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ResourcesModule = () => {
  const loaderData = useLoaderData()
  const { displayError } = useDisplayError()

  const [, setNav] = PageNavContainer.useContainer()

  const [categoriesResult] = useQuery({ query: ResourceCategoriesQuery })

  const { data: categoriesData, error: categoriesError } = categoriesResult

  useEffect(() => {
    if (categoriesError) {
      displayError(`Couldn’t load resource categories`, categoriesError)
    }
  }, [categoriesError, displayError])

  const categoriesHaveNotBeenFetched = !categoriesData
  const categoriesNames = categoriesHaveNotBeenFetched
    ? []
    : categoriesData.resourceCategories.nodes.map((item) => item.name)

  const [resourcesResult] = useQuery({
    query: categoriesHaveNotBeenFetched
      ? ``
      : createCombinedResourcesQuery(categoriesNames),
    variables: categoriesHaveNotBeenFetched
      ? {}
      : mapCategoriesToQueryVariables(categoriesNames),
    pause: categoriesHaveNotBeenFetched,
  })

  const { data, error } = resourcesResult

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      Header: OldAppHeader,
    })
  }, [setNav])

  useEffect(() => {
    if (error) {
      displayError(`Couldn’t load resources`, error)
    }
  }, [error, displayError])

  return !data || error ? (
    <LoadOverlay />
  ) : (
    <Resources
      resources={data}
      content={loaderData.page.content}
      resourceCategories={categoriesNames}
    />
  )
}

export default ResourcesModule
